import dayjs from 'dayjs';

const formatDate = (date: string, format = 'YYYY/MM/DD') => {
  if (!date) return '';
  const dateObject = dayjs(date);
  if (!dateObject.isValid()) return '';
  return dateObject.format(format);
};
export default formatDate;
